import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Button,
  ButtonGroup,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import moment from "moment";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { puede } from "../../../../permisos/permisos";

function ListadoRecepcionArticulos() {
  const { user } = useContext(AuthContext);
  const URL_OCA = process.env.REACT_APP_URL_ORDENES_COMPRA_ARTICULOS;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 60);
  let fin = new Date();
  fin.setDate(fin.getDate() + 1); // margen por zona horaria
  let endDate = moment(fin).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [todas, setTodas] = useState([]); // órdenes no canceladas (para el selector)

  // Mail
  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  // Selector de orden a recibir
  const [modalPicker, setModalPicker] = useState(false);
  const togglePicker = () => setModalPicker(!modalPicker);

  // Recepción
  const [modalRec, setModalRec] = useState(false);
  const toggleRec = () => setModalRec(!modalRec);
  const [ocaSel, setOcaSel] = useState(null);
  const [area, setArea] = useState("");
  const [recepciones, setRecepciones] = useState({});
  const [recFecha, setRecFecha] = useState(moment().format("YYYY-MM-DD"));
  const [recFactura, setRecFactura] = useState("NA");
  const [recPais, setRecPais] = useState("Mexico");
  const [recObservaciones, setRecObservaciones] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const ITEMS_PER_PAGE = 50;

  useEffect(() => {
    getOrdenes();
    axios.get(URL_ARTICULOS, headers).then((r) => setArticulos(r.data)).catch((e) => console.log(e));
    axios.get(URL_AREAS, headers).then((r) => setAreas(r.data)).catch((e) => console.log(e));
    axios.get(URL_PROVEEDORES, headers).then((r) => setProveedores(r.data)).catch((e) => console.log(e));
  }, []);

  function getOrdenes() {
    // Selector de órdenes a recibir (abiertas = todas menos cerradas/canceladas).
    axios
      .get(URL_OCA, headers)
      .then((r) => {
        let allOrdenes = (r.data || []).filter(
          (a) => a.estado !== "Cancelada" && a.estado !== "Cerrada"
        );
        setTodas(allOrdenes);
      })
      .catch((e) => console.log(e));

    // Tabla = compras (recepciones) de PRODUCTO TERMINADO desde la colección Compras.
    axios
      .get(`${URL_COMPRAS}ProductoTerminado/2000-01-01/2100-12-31`, headers)
      .then((r) => {
        let arrayTabla = (r.data || []).map((a) => {
          const prov = a.proveedores?.[0];
          const oca = a.ordenCompraArticulos;
          return {
            _id: a._id,
            folio: a.idCompras,
            numeroOC: a.numeroOrdenPT || (oca ? oca.idOCA : "-"),
            fecha: a.fecha,
            proveedor: prov ? (prov.razon_social || prov.nombre_comercial) : "NA",
            idProveedor: prov ? prov._id : "",
            factura: a.factura_proveedor || "NA",
            cantidadRecibida: a.total_piezas || 0,
            total: a.total_costo || 0,
            raw: a,
          };
        });
        setComments(arrayTabla);
      })
      .catch((e) => console.log(e));
  }

  // ---- Recepción ----
  function abreRecepcion(oca) {
    setModalPicker(false);
    setOcaSel(oca);
    setArea("");
    setRecFecha(moment().format("YYYY-MM-DD"));
    setRecFactura("NA");
    // Prellena con lo pendiente por línea.
    const init = {};
    oca.articulos.forEach((l) => { init[l._id] = Math.max(0, Number(l.cantidad) - Number(l.recibida)); });
    setRecepciones(init);
    toggleRec();
  }
  function guardarRecepcion() {
    const recArray = Object.entries(recepciones)
      .map(([lineaId, cantidad]) => ({ lineaId, cantidad: Number(cantidad) }))
      .filter((r) => r.cantidad > 0);
    if (!area) {
      Swal.fire("Atención", "Selecciona el área destino", "warning");
      return;
    }
    if (!recArray.length) {
      Swal.fire("Atención", "Indica cantidades a recibir", "warning");
      return;
    }
    axios.patch(`${URL_OCA}Recibir/${ocaSel._id}`, {
      recepciones: recArray, area: area || null,
      fecha: recFecha || moment().format("YYYY-MM-DD"),
      factura: recFactura || "NA",
    }, headers)
      .then(() => {
        axios.post(URL_LOGS, { tipo: "Recibir OC Articulos", detalle: `OCA ${ocaSel.idOCA}`, user: user.id }, headers);
        toggleRec();
        Swal.fire("Listo!", "Mercancía recibida en Producto Terminado", "success");
        window.location.reload();
      })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? error.response.data.message || error.response.data : error}` }));
  }

  // PDF de la recepción (Compra PT) — partidas desde la orden ligada.
  function PDFOC(o) {
    const oca = o.raw ? o.raw.ordenCompraArticulos : null;
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 12, 45, 15);
    doc.setFontSize(14);
    doc.text(`Recepción PT — Compra #${o.folio}`, 14, 18);
    doc.setFontSize(11);
    doc.text(`N° Orden de Compra: ${o.numeroOC}`, 14, 26);
    doc.text(`Fecha: ${o.fecha}`, 14, 32);
    doc.text(`Proveedor: ${o.proveedor}`, 14, 38);
    doc.text(`Factura: ${o.factura}`, 14, 44);
    const body = (oca && oca.articulos ? oca.articulos : []).map((l) => [
      l.articulo ? l.articulo.descripcion : "-",
      l.color ? l.color.name : "-",
      l.recibida,
      "$" + Number(l.costo || 0).toLocaleString("es-MX"),
      "$" + Number(Number(l.recibida || 0) * Number(l.costo || 0)).toLocaleString("es-MX"),
    ]);
    doc.autoTable({
      head: [["Artículo", "Color", "Recibido", "Precio", "Total"]],
      body,
      startY: 50,
      foot: [["", "", "", "Total", "$" + Number(o.total || 0).toLocaleString("es-MX")]],
      showFoot: "lastPage",
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  const badgeEstado = (e) => {
    const map = { Recibida: "success", Parcial: "warning", Cancelada: "danger", Cerrada: "dark", Pendiente: "secondary" };
    return <span className={`badge badge-${map[e] || "secondary"}`}>{e}</span>;
  };

  const tableHeaders = [
    { name: "Folio", field: "folio", sortable: true },
    { name: "N° OC", field: "numeroOC", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Proveedor", field: "proveedor", sortable: false },
    { name: "Factura", field: "factura", sortable: false },
    { name: "Cant. Recibida", field: "cantidadRecibida", sortable: true },
    { name: "Total", field: "total", sortable: true },
    { name: "PDF", field: "pdf", sortable: false },
  ];

  // PDF del listado completo (respeta el filtro de fechas / búsqueda visibles).
  function PDFTabla() {
    const filas = comments
      .filter((c) => (!selectedFechaInicio || c.fecha >= selectedFechaInicio))
      .filter((c) => (!selectedFechaFin || c.fecha <= selectedFechaFin))
      .map((c) => [
        c.folio,
        c.numeroOC,
        c.fecha,
        c.proveedor,
        c.factura,
        c.cantidadRecibida,
        "$" + Number(c.total || 0).toLocaleString("es-MX"),
      ]);
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 12, 45, 15);
    doc.text("Recepciones — Producto Terminado", 14, 20);
    doc.setFontSize(11);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 14, 27);
    doc.autoTable({
      head: [["Folio", "N° OC", "Fecha", "Proveedor", "Factura", "Recibido", "Total"]],
      body: filas,
      startY: 32,
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const data = comments
      .filter((c) => (!selectedFechaInicio || c.fecha >= selectedFechaInicio))
      .filter((c) => (!selectedFechaFin || c.fecha <= selectedFechaFin))
      .map((c) => ({
        Folio: c.folio,
        "N° OC": c.numeroOC,
        Fecha: c.fecha,
        Proveedor: c.proveedor,
        Factura: c.factura,
        Recibido: c.cantidadRecibida,
        Total: c.total,
      }));
    new ExportJsonExcel({
      fileName: "RecepcionesProductoTerminado",
      datas: [{ sheetData: data, sheetName: "Recepciones" }],
    }).saveExcel();
  }

  // Envía el listado por correo (PDF adjunto).
  function enviaMail() {
    const filas = comments
      .filter((c) => (!selectedFechaInicio || c.fecha >= selectedFechaInicio))
      .filter((c) => (!selectedFechaFin || c.fecha <= selectedFechaFin))
      .filter((c) => (!selectedProveedor || c.idProveedor === selectedProveedor))
      .map((c) => [
        c.folio, c.numeroOC, c.fecha, c.proveedor, c.factura, c.cantidadRecibida,
        "$" + Number(c.total || 0).toLocaleString("es-MX"),
      ]);
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 12, 45, 15);
    doc.text("Recepciones — Producto Terminado", 14, 20);
    doc.setFontSize(11);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 14, 27);
    doc.autoTable({
      head: [["Folio", "N° OC", "Fecha", "Proveedor", "Factura", "Recibido", "Total"]],
      body: filas,
      startY: 32,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Recepciones Producto Terminado",
          email: mailTo,
          fileName: "RecepcionesProductoTerminado.pdf",
          att: base64File,
          text: `<p>Hola,</p><p>Adjunto encontrarás el listado de recepciones de Producto Terminado.</p>`,
        },
        headers
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? error.response.data : error}` }));
  }

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          (comment.proveedor || "").toLowerCase().includes(search.toLowerCase()) ||
          (comment.factura || "").toLowerCase().includes(search.toLowerCase()) ||
          comment.total.toString().includes(search) ||
          comment.folio.toString().includes(search) ||
          comment.numeroOC.toString().includes(search)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter((e) => e.fecha >= selectedFechaInicio);
    }
    if (selectedFechaFin) {
      computedComments = computedComments.filter((e) => e.fecha <= selectedFechaFin);
    }
    if (selectedProveedor) {
      computedComments = computedComments.filter((e) => e.idProveedor === selectedProveedor);
    }

    setTotalItems(computedComments.length);

    const numericos = ["folio", "numeroOC", "total", "cantidadRecibida"];
    if (sorting.field && !numericos.includes(sorting.field)) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * (a[sorting.field] || "").toString().localeCompare((b[sorting.field] || "").toString())
      );
    }
    if (sorting.field && sorting.order === "asc" && numericos.includes(sorting.field)) {
      computedComments = computedComments.sort((a, b) => (parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1));
    }
    if (sorting.field && sorting.order === "desc" && numericos.includes(sorting.field)) {
      computedComments = computedComments.sort((a, b) => (parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1));
    }

    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, selectedFechaInicio, selectedFechaFin, selectedProveedor]);

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "compras.recepcionPT.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-truck-loading" style={{ marginRight: 8, color: "#0ea5e9" }} />
                  Recepción — Producto Terminado
                </h3>
                <p className="page-subtitle">Recepción de órdenes de compra → inventario de Producto Terminado</p>
              </div>
              <div className="page-actions">
                <Button size="sm" color="success" onClick={togglePicker} style={{ marginRight: 8 }}>
                  <i className="fas fa-truck-loading" style={{ marginRight: 6 }} /> Recibir Orden de Compra
                </Button>
                <ButtonGroup id="logoutBoton">
                  <Button size="sm" className="btn" color="danger" onClick={PDFTabla}>
                    PDF <i className="far fa-file-pdf"></i>
                  </Button>
                  <Button size="sm" className="btn" color="secondary" onClick={toggleMail}>
                    eMail <i className="fas fa-at"></i>
                  </Button>
                  <Button size="sm" className="btn" color="primary" onClick={excel}>
                    Excel <i className="far fa-file-excel"></i>
                  </Button>
                </ButtonGroup>
              </div>
            </div>

            <div className="row">
              <div className="col-md-8">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
              <div className="col-md-4 d-flex flex-row-reverse">
                <Search
                  onSearch={(value) => {
                    setSearch(value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Fecha Inicio</Label>
                <Input
                  bsSize="sm"
                  type="date"
                  value={selectedFechaInicio}
                  required
                  onChange={(e) => {
                    setSelectedFechaInicio(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Fecha Fin</Label>
                <Input
                  bsSize="sm"
                  type="date"
                  value={selectedFechaFin}
                  required
                  onChange={(e) => {
                    setSelectedFechaFin(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedProveedor}
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Todos</option>
                  {proveedores
                    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                    .map((p) => (
                      <option key={p._id} value={p._id}>{p.nombre_comercial}</option>
                    ))}
                </Input>
              </Col>
            </Row>
            <br />
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <TableHeader
                headers={tableHeaders}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {commentsData.map((o) => (
                  <tr key={o._id}>
                    <td>{o.folio}</td>
                    <td>{o.numeroOC}</td>
                    <td>{o.fecha}</td>
                    <td>{o.proveedor}</td>
                    <td>{o.factura}</td>
                    <td>{o.cantidadRecibida}</td>
                    <td>${Number(o.total || 0).toLocaleString("es-MX")}</td>
                    <td>
                      <Button color="danger" size="sm" onClick={() => PDFOC(o)} title="PDF">
                        <i className="far fa-file-pdf"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
                {commentsData.length === 0 && (
                  <tr>
                    <td colSpan={8} className="text-muted" style={{ textAlign: "center" }}>
                      Sin compras recibidas en el rango.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="col-md-6">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
          </div>
        ) : undefined}
      </div>

      {/* Enviar por correo */}
      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}>Enviar listado por correo</ModalHeader>
        <ModalBody>
          <Label>Correo destino</Label>
          <Input type="email" value={mailTo} onChange={(e) => setMailTo(e.target.value)} placeholder="correo@ejemplo.com" />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={enviaMail} disabled={!mailTo}>
            <i className="fas fa-paper-plane" style={{ marginRight: 6 }} /> Enviar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Selector de orden a recibir */}
      <Modal size="lg" isOpen={modalPicker} toggle={togglePicker}>
        <ModalHeader toggle={togglePicker}>
          <i className="fas fa-truck-loading" style={{ marginRight: 8, color: "#0ea5e9" }} />
          Selecciona la Orden de Compra a recibir
        </ModalHeader>
        <ModalBody>
          {todas.length === 0 ? (
            <p className="text-muted">No hay órdenes pendientes de recibir.</p>
          ) : (
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <thead>
                <tr>
                  <th className="tituloTabla">Folio</th>
                  <th className="tituloTabla">Fecha</th>
                  <th className="tituloTabla">Proveedor</th>
                  <th className="tituloTabla"># Artículos</th>
                  <th className="tituloTabla">Total</th>
                  <th className="tituloTabla">Estado</th>
                  <th className="tituloTabla">Recibir</th>
                </tr>
              </thead>
              <tbody>
                {todas.map((o) => (
                  <tr key={o._id}>
                    <td>{o.idOCA}</td>
                    <td>{o.fecha}</td>
                    <td>{o.proveedor ? o.proveedor.nombre_comercial : "NA"}</td>
                    <td>{(o.articulos || []).length}</td>
                    <td>${Number(o.total || 0).toLocaleString("es-MX")}</td>
                    <td>{badgeEstado(o.estado)}</td>
                    <td>
                      {puede(user, "compras.recepcionPT.recibir") && (
<Button color="primary" size="sm" onClick={() => abreRecepcion(o)} title="Recibir">
                        <i className="fas fa-truck-loading"></i>
                      </Button>
)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </ModalBody>
      </Modal>

      {/* Recepción */}
      <Modal size="lg" isOpen={modalRec} toggle={toggleRec}>
        <ModalHeader toggle={toggleRec}>
          <i className="fas fa-truck-loading" style={{ marginRight: 8, color: "#0ea5e9" }} />
          Recibir Orden {ocaSel ? `#${ocaSel.idOCA}` : ""}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Fecha</Label>
              <Input type="date" value={recFecha} onChange={(e) => setRecFecha(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Factura proveedor</Label>
              <Input type="text" value={recFactura} onChange={(e) => setRecFactura(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Área destino *</Label>
              <Input type="select" value={area} onChange={(e) => setArea(e.target.value)}>
                <option value="">Selecciona...</option>
                {areas
                  .filter((ar) => ar._id !== AREAS_GENERAL)
                  .map((ar) => (
                    <option key={ar._id} value={ar._id}>{ar.name || ar.nombre}</option>
                  ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless>
            <thead>
              <tr>
                <th>Artículo</th>
                <th>Color</th>
                <th>Pedido</th>
                <th>Recibido</th>
                <th>Pendiente</th>
                <th>Recibir ahora</th>
              </tr>
            </thead>
            <tbody>
              {ocaSel && ocaSel.articulos.map((l) => {
                const pendiente = Number(l.cantidad) - Number(l.recibida);
                return (
                  <tr key={l._id}>
                    <td>{l.articulo ? l.articulo.descripcion : "-"}</td>
                    <td>{l.color ? l.color.name : "-"}</td>
                    <td>{l.cantidad}</td>
                    <td>{l.recibida}</td>
                    <td>{pendiente}</td>
                    <td>
                      <Input
                        type="number"
                        bsSize="sm"
                        min="0"
                        value={recepciones[l._id] !== undefined ? recepciones[l._id] : ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          setRecepciones((prev) => ({ ...prev, [l._id]: val }));
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarRecepcion}>
            <i className="fas fa-truck-loading" style={{ marginRight: 6 }} /> Recibir a inventario
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoRecepcionArticulos;
